import InvoiceAzure from '../../models/InvoiceAzure'
import { ApiAction, ApiState, initialApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'

export interface InvoiceAzureState extends ApiState {
  doc?: InvoiceAzure
}

const InvoicesAzure = (state: InvoiceAzureState = initialApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<InvoiceAzureState>('INVOICE_AZURE')(state, action)
  }
}

export default InvoicesAzure
